import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';

/**
 * 吹き出し管理 基礎クラス
 */
export default class BalloonClass extends BaseClass {
  constructor() {
    super();
    this.name = 'BalloonClass';

    this.isOpen = false;

    this.balloonSelector = '.css_balloon';
    this.clickSelector = '.js-balloon';

    this.openTarget = null;
  }

  onCreate() {
    this.balloon = $(this.balloonSelector);

    $(this.clickSelector).on('click', (e) => {
      e.preventDefault();
      const _this = $(e.currentTarget);
      if (this.isOpen && _this.is(this.openTarget)) {
        this.onClose();
      } else {
        this.onOpen(_this);
      }
    });

    $(document).on('click touchstart', (e) => {
      if (!$(e.target).closest(this.balloonSelector).length && !$(e.target).filter(this.clickSelector).length && this.isOpen) {
        this.onClose();
      }
    });
  }

  onResize() {
    super.onResize();
    if (!this.isOpen) { return; }

    this.positionSet(this.openTarget);
  }

  onOpen(_target) {
    this.isOpen = true;
    this.openTarget = _target;
    this.balloon.css({ display: 'block' });
    this.positionSet(_target);
  }

  onClose() {
    this.balloon.css({ display: '' });
    this.isOpen = false;
  }

  positionSet(_target) {
    const offset = _target.offset();
    const top = offset.top + _target.height();
    let left = offset.left + _target.width() / 2;
    // if(Util.isBreakpoint) left = "";
    this.balloon.css({ top: top, left: left });
  }
}
